export const NOTIFICATIONS_EVENTS = {
  NOTIFICATIONS_BELL_CLICKED: 'Notifications Bell Clicked',
  NOTIFICATION_CLICKED: 'Notification Clicked',
  PUSH_NOTIFICATION_REMINDER_RECEIVED: 'Push Notification Reminder Received',
  PUSH_NOTIFICATION_CLICKED: 'Push Notification Clicked',
};
